import { Injector, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SuccessAlertDialogComponent } from '@components/dialogs/success-alert-dialog/success-alert-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorsService {
  private dialog: any;

  constructor(private injector: Injector) {
    this.dialog = this.injector.get(MatDialog);
  }

  public showDialogError(error: any): void {
    if (error?.error?.statusCode) {
      this.dialog.open(SuccessAlertDialogComponent, {
        width: '400px',
        data: `${error?.error?.message}`,
      });
    }
  }
}
